const FORM_OF_CLASS_TRANSLATIONS = {
  cwiczenia: 'Classes',
  'cwiczenia kliniczne': 'Clinical classes',
  'cwiczenia laboratoryjne': 'Laboratory classes',
  'cwiczenia projektowe': 'Project classes',
  'cwiczenia r': 'Classes R',
  'cwiczenia terenowe': 'Field classes',
  'e-learning': 'E-learning',
  konwersatorium: 'Conversatory',
  laboratoria: 'Laboratories',
  laboratorium: 'Laboratory',
  lektorat: 'Language class',
  praktyka: 'Internship',
  projekt: 'Project',
  samoksztalcenie: 'Self-study',
  'samoksztalcenie ck': 'Self-study CK',
  'samoksztalcenie cw': 'Self-study classes',
  'samoksztalcenie w': 'Self-study lectures',
  seminarium: 'Seminar',
  warsztaty: 'Workshops',
  wyklad: 'Lecture',
  wykład: 'Lecture',
  'zajecia praktyczne': 'Practical classes',
  'zajecia sportowe': 'Sports classes',
  'zajecia terenowe': 'Field classes',
}

const FORM_OF_CREDIT_TRANSLATIONS = {
  'bez oceny': 'Pass without grade',
  egzamin: 'Exam',
  'zal z ocena': 'Graded pass',
  zaliczenie: 'Credit',
  'zaliczenie bez oceny': 'Pass without grade',
  'zaliczenie na ocene': 'Graded pass',
}

const CATEGORY_TRANSLATIONS = {
  kompetencje: 'Competences',
  'kompetencje spoleczne': 'Social competences',
  umiejetnosci: 'Skills',
  wiedza: 'Knowledge',
}

const BASIC_INFORMATION_VALUE_TRANSLATIONS = {
  'i stopien': 'first-cycle studies',
  'i stopnia': 'first-cycle studies',
  'ii stopien': 'second-cycle studies',
  'ii stopnia': 'second-cycle studies',
  'drugiego stopnia': 'second-cycle studies',
  'jednolite studia magisterskie': 'long-cycle Master’s studies',
  niestacjonarne: 'part-time',
  ogolnoakademicki: 'general academic',
  ogolnorozwojowy: 'general development',
  'pierwszego stopnia': 'first-cycle studies',
  polski: 'Polish',
  praktyczny: 'practical',
  stacjonarne: 'full-time',
  'trzeciego stopnia': 'third-cycle studies',
}

const FACULTY_TRANSLATIONS = {
  'centrum ksztalcenia podyplomowego': 'Center for Postgraduate Education',
  rehabilitacji: 'Rehabilitation',
  rehabilitacja: 'Rehabilitation',
  'szkola doktorska': 'Doctoral School',
  'turystyki i rekreacji': 'Tourism and Recreation',
  'turystyki i zdrowia': 'Tourism and Health',
  'wychowania fizycznego': 'Physical Education',
  'wychowania fizycznego i sportu': 'Physical Education and Sport',
  'wychowania fizycznego i zdrowia': 'Physical Education and Health',
}

const normalizeFormOfClassName = (name) => {
  return name
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/ł/g, 'l')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\.+/g, '')
    .replace(/[\u002d\u2010-\u2015\u2212]+/g, ' ')
    .replace(/\s+/g, ' ')
}

const isEnglishLanguage = (language) => {
  return ['english', 'angielski', 'en'].includes(language?.toString().trim().toLowerCase())
}

const isTranslationDebugEnabled = () => {
  return typeof window !== 'undefined' &&
    window.localStorage?.getItem('debugSyllabusTranslations') === '1'
}

const translateSyllabusDictionaryValue = (name, language, translations, dictionaryName) => {
  if (!name || !isEnglishLanguage(language)) return name

  const normalizedName = normalizeFormOfClassName(name)
  const translatedName = translations[normalizedName] || name

  if (isTranslationDebugEnabled()) {
    console.debug('[syllabus translations]', {
      dictionaryName,
      language,
      name,
      normalizedName,
      translatedName,
    })
  }

  return translatedName
}

export const translateFormOfClass = (name, language) => {
  return translateSyllabusDictionaryValue(name, language, FORM_OF_CLASS_TRANSLATIONS, 'formOfClass')
}

export const translateFormOfCredit = (name, language) => {
  return translateSyllabusDictionaryValue(name, language, FORM_OF_CREDIT_TRANSLATIONS, 'formOfCredit')
}

export const translateSyllabusCategory = (name, language) => {
  return translateSyllabusDictionaryValue(name, language, CATEGORY_TRANSLATIONS, 'category')
}

export const translateBasicInformationValue = (value, information, language) => {
  if ([null, undefined, ''].includes(value) || !isEnglishLanguage(language)) return value

  const normalizedValue = information === 'language' && value.toString() === '0' ? 'Polski' : value

  if (information === 'row_11') {
    return normalizedValue
      .toString()
      .replace(/\bRok\b/g, 'Year')
      .replace(/\brok\b/g, 'year')
      .replace(/\bSemestr\b/g, 'Semester')
      .replace(/\bsemestr\b/g, 'semester')
  }

  return translateSyllabusDictionaryValue(
    normalizedValue,
    language,
    BASIC_INFORMATION_VALUE_TRANSLATIONS,
    'basicInformationValue',
  )
}

export const translateFaculty = (name, language) => {
  return translateSyllabusDictionaryValue(name, language, FACULTY_TRANSLATIONS, 'faculty')
}

export const translateSyllabusListValue = (value, field, language) => {
  if (field === 'faculty') return translateFaculty(value, language)

  return translateBasicInformationValue(value, field, language)
}

export const translateSyllabusDictionaryOption = (option, field, language) => {
  return {
    ...option,
    text: translateSyllabusListValue(option.text, field, language),
  }
}

export const translateSyllabusHeaderEducation = (value, language) => {
  if ([null, undefined, ''].includes(value) || !isEnglishLanguage(language)) return value

  return value
    .toString()
    .split(',')
    .map(part => {
      const leadingWhitespace = part.match(/^\s*/)[0]
      const trailingWhitespace = part.match(/\s*$/)[0]
      const translatedPart = translateBasicInformationValue(part.trim(), 'header', language)

      return `${leadingWhitespace}${translatedPart}${trailingWhitespace}`
    })
    .join(',')
}
